import SearchRepository from "@adapters/features/Search/Repository/Search";
export default (http) => {
    return {
        search: new SearchRepository(http),
    };
};
